<template>
  <div class="toast">
    <div class="prize-list">
      <div
        class="prize-item"
        :class="{ 'prize-item-one': prizeList.length <= 1 }"
        v-for="(item, index) in prizeList"
        :key="index"
      >
        <img
          class="prize-flag"
          v-if="item.type == 2"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/db08454fe36f9a245d648b5538ddc448.png"
          alt=""
        />
        <img class="prize-image" :src="item.goods_img" alt="" />
        <div class="prize-name">{{ item.goods_name }}</div>
      </div>
    </div>
    <img
      class="bg"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2be9065fc2db1d105bbba5a1b21146b7.png"
      alt=""
    />
    <div class="bottom">
      <img
        class="b-mask"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/47b690d874d43d235bb28ff47234e203.png"
        alt=""
      />
      <div class="btn-list">
        <img
          class="btn-item btn-confirm"
          v-if="type == 1"
          @click="bindConfirm"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fad109e7a5ff1eb898b33ce892c40230.png"
          alt=""
        />
        <img
          class="btn-item btn-confirm"
          v-else
          @click="bindJumpDetail"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/03ca8640ce1744b716d169b5d6cb84e2.png"
          alt=""
        />
        <div class="btn-item btn-cancel" @click="bindCancel">继续转换</div>
      </div>
    </div>
    <div class="close iconfont icon-cha" @click="bindCancel"></div>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    type() {
      if (this.options?.gift) {
        return 2
      } else {
        return 1
      }
    },
    prizeList() {
      let res = []
      if (this.options?.integral) {
        res.push({
          type: 1,
          goods_name: '积分 x' + this.options.integral,
          goods_url: '',
          goods_img:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/12a13838d51d822bd19b4b945b1ffb65.png'
        })
      }
      if (this.options?.gift) {
        res.push({
          type: 2,
          goods_name: this.options.gift.goods_name,
          goods_url: this.options.gift.goods_url,
          goods_img: this.options.gift.goods_img
        })
      }
      return res
    }
  },
  methods: {
    bindCancel() {
      this.$emit('cancel')
    },
    bindConfirm() {
      this.$emit('confirm')
    },
    bindJumpDetail() {
      if (this.options?.gift?.goods_url) {
        location.href = this.options.gift.goods_url
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.toast {
  position: relative;
  box-sizing: border-box;
  animation: myscale 0.3s ease;

  .bg {
    width: 307px;
  }

  .prize-list {
    position: absolute;
    width: 248px;
    left: 50%;
    top: 170px;
    transform: translate(-50%, 0%);
    display: flex;
    align-items: center;
    justify-content: center;

    .prize-item {
      position: relative;
      padding-top: 6px;
      box-sizing: border-box;
      width: 107px;
      height: 113px;
      background: linear-gradient(163deg, #ffffff 0%, #fae4ab 100%);
      border-radius: 8px;
      margin-right: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .prize-flag {
        position: absolute;
        width: 49px;
        height: 49px;
        right: -1px;
        top: -1px;
        z-index: 1;
      }

      .prize-image {
        width: 83px;
        height: 52px;
        object-fit: contain;
      }

      .prize-name {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #c47f2f;
        line-height: 18px;
      }
    }

    .prize-item:last-child {
      margin-right: 0;
    }

    .prize-item-one {
      width: 172px;
    }
  }

  .bottom {
    width: 248px;
    height: 114px;
    position: absolute;
    z-index: 9;
    left: 50%;
    transform: translate(-50%, 0%);
    bottom: 24px;

    .b-mask {
      width: 100%;
    }

    .btn-list {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0%);
      top: 34px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .btn-confirm {
        width: 164px;
        height: 40px;
        object-fit: contain;
        margin-bottom: 10px;
      }

      .btn-cancel {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #fcdda0;
        line-height: 18px;
      }
    }
  }

  .close {
    position: absolute;
    left: 50%;
    bottom: -30px;
    transform: translate(-50%, 0%);
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 12px;
    border: 0.5px solid #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 600;
  }
}

@keyframes myscale {
  0% {
    transform: scale(0.3);
  }

  80% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}
</style>
